import React, { useEffect, useRef } from 'react'
import useCurrentUser from 'hooks/useCurrentUser'

const constructChat = (scriptSrc) => (props) => {
  const { hash, name, email, image, username } = useCurrentUser()
  const onBitrixLiveChat = useRef()

  useEffect(() => {
    if (!hash) {
      return
    }

    const script = document.createElement('script')

    script.setAttribute('async', true)
    script.src = scriptSrc + '?' + (Date.now() / 60000 | 0)

    onBitrixLiveChat.current = (event) => {
      event.detail.widget.setUserRegisterData({
        'hash': hash,
        'name': name.split(' ').slice(0, -1).join(' '),
        'lastName': name.split(' ').slice(-1).join(' '),
        'avatar': image,
        'email': email,
      })

      event.detail.widget.setCustomData(`Name: [b]${name}[/b] <br /> Username: ${username} <br /> Email: ${email} <br /> started chat from Voice Portal`);
      
    }

    window.addEventListener('onBitrixLiveChat', onBitrixLiveChat.current)

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
      if (onBitrixLiveChat.current) {
        window.removeEventListener('onBitrixLiveChat', onBitrixLiveChat.current)
      }
    }
  }, [hash])

  return null
}

const CustomerChat = constructChat('https://my.arnsbogroup.com/upload/crm/site_button/loader_7_mox5d3.js')
const SupplierChat = constructChat('https://my.arnsbogroup.com/upload/crm/site_button/loader_7_mox5d3.js')

export {
  CustomerChat,
  SupplierChat,
}
